import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-elbow-left', 'ArrowElbowLeft', [["path",{"d":"M3 14v-6h6"}],["path",{"d":"M3 8l9 9l9 -9"}]]);